import { IRowVersionableDto } from '../common/rowVersionable';
import { PaymentMethod, PaymentStatus } from '../subscriptions/subscription.enums';
import { BookingStatus, EventStatus } from "./training.enums";

export class AddEventTypeDto {
    title: string;
    info: string;
    subscriberCost: number;
    supplierCost: number;
}

export class AddEventDto {
    title: string;
    info: string;
    description: string;
    subscriberCost: number;
    supplierCost: number;
    eventDate: string;
    eventStartTime: string;
    eventEndTime: string;
    duration: number;
    virtual: boolean;
    eventTypeId: number;
    venue: string;
    participantLimit: number;
}

export class EditEventTypeDto implements IRowVersionableDto {
    id: number;
    title: string;
    info: string;
    subscriberCost: number;
    supplierCost: number;
    rowVersion: string;

    constructor(getDto: GetEventTypeDto) {
        this.id = getDto.id;
        this.title = getDto.title;
        this.info = getDto.info;
        this.subscriberCost = getDto.subscriberCost;
        this.supplierCost = getDto.supplierCost;
        this.rowVersion = getDto.rowVersion;
    }
}

export class EditEventDto implements IRowVersionableDto {
    id: number;
    title: string;
    info: string;
    description: string;
    subscriberCost: number;
    supplierCost: number;
    eventDateTime: string;
    eventDate: string;
    eventStartTime: string;
    eventEndTime: string;
    duration: number;
    virtual: boolean;
    eventTypeId: number;
    venue: string;
    state: EventStatus;
    numParticipants: number;
    participantLimit: number;
    rowVersion: string;

    constructor(getDto: GetEventDto) {
        this.id = getDto.id;
        this.title = getDto.title;
        this.info = getDto.info;
        this.description = getDto.description;
        this.subscriberCost = getDto.subscriberCost;
        this.supplierCost = getDto.supplierCost;
        this.eventDateTime = getDto.eventDateTime;
        this.eventDate = getDto.eventDate;
        this.eventStartTime = getDto.eventStartTime;
        this.eventEndTime = getDto.eventEndTime;
        this.duration = getDto.duration;
        this.virtual = getDto.virtual;
        this.eventTypeId = getDto.eventTypeId;
        this.venue = getDto.venue;
        this.state = getDto.state;
        this.numParticipants = getDto.numParticipants;
        this.participantLimit = getDto.participantLimit;
        this.rowVersion = getDto.rowVersion;
    }
}

export class GetEventTypeDto implements IRowVersionableDto {
    id: number;
    title: string;
    info: string;
    subscriberCost: number;
    supplierCost: number;
    rowVersion: string;
}

export class GetEventDto implements IRowVersionableDto {
    id: number;
    title: string;
    info: string;
    eventTypeTitle: string;
    eventTypeInfo: string;
    description: string;
    subscriberCost: number;
    supplierCost: number;
    eventDateTime: string;
    eventDateTimeMilliseconds: number;
    eventTime: string;
    eventDate: string;
    eventStartTime: string;
    eventEndTime: string;
    jsEventDateTime: string;
    jsEventDate: string;
    duration: number;
    virtual: boolean;
    eventTypeId: number;
    venue: string;
    state: EventStatus;
    stateText: string;
    numParticipants: number;
    participantLimit: number;
    placesAvailable: number;
    participants: Array<ParticipantDto>;
    rowVersion: string;
}

export class BookedEventSummaryDto {
    //payment: GetTrainingPaymentDto;
    //booking: BookingDto;

    paymentId: number;
    paymentMethod: PaymentMethod;
    paymentStatus: PaymentStatus;
    paymentStatusText: string;
    amount: number;
    additionalInformation: string;
    jsAttemptedOn: number;
    stripeChargeId: string;
    hasReceipt: boolean;
    paymentRowVersion: string;
    trainingInvoiceId: number;

    bookingId: number;
    customerId: number;
    eventId: number;
    bookingStatus: BookingStatus;
    bookingStatusText: string;
    allergies: string;
    numPlaces: number;
    cost: number;
    participants: Array<ParticipantDto>;
    delegatesList: string;
    formData: any;
    rowVersion: string;
    title: string;
    jsEventDateTime: string;
    jsEventDateStartEnd: string;
    eventInfo: string;
}

export class DeleteEventTypeDto implements IRowVersionableDto {
    id: number;
    rowVersion: string;
}

export class DeleteEventDto implements IRowVersionableDto {
    id: number;
    rowVersion: string;
}

export class ParticipantDto implements IRowVersionableDto {
    id: number;
    bookingId: number;
    customerId: number;
    eventId: number;
    name: string;
    email: string;
    rowVersion: string;
}

export class BookingDto implements IRowVersionableDto {
    id: number;
    customerId: number;
    eventId: number;
    status: BookingStatus;
    statusText: string;
    allergies: string;
    numPlaces: number;
    cost: number;
    participants: Array<ParticipantDto>;
    delegatesList: string;
    formData: any;
    rowVersion: string;
    title: string;
    jsEventDateTime: string;
    jsEventDateStartEnd: string;
    eventInfo: string;
}

export class TrainingPaymentDto {
    bookingId: number;
    paymentMethod: PaymentMethod;
    customerId: number;
    additionalInformation?: string;
}

export class TrainingCardPaymentDto extends TrainingPaymentDto {
    stripeToken: string;
    is3DSecure: boolean;
    clientSecret: string;
}

export class GetTrainingPaymentDto implements IRowVersionableDto {
    id: number;
    paymentMethod: PaymentMethod;
    status: PaymentStatus;
    statusText: string;
    amount: number;
    additionalInformation: string;
    jsAttemptedOn: number;
    stripeChargeId: string;
    hasReceipt: boolean;
    bookingId: number;
    rowVersion: string;
    trainingInvoiceId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/training/training.models.ts